<template>
  <Modal @close="close" :hide-footer="true" size="large">
    <template #body>
      <div class="d-flex justify-content-around">
        <img class="screenshot" :src="data.url" />
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/display/Modal";

export default {
  name: "ImageViewerModal",
  props: {
    data: Object,
    validator: (value) => {
      return !!value.url;
    },
  },
  components: {
    Modal,
  },
  setup(props, { emit }) {
    const close = () => emit("close");

    return {
      close,
    };
  },
};
</script>

<style lang="scss" scoped>
img.screenshot {
  width: 380px;
  height: auto;
  cursor: pointer;
}
</style>
